import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { authorizationsApiActions } from 'src/app/store/actions/authorizatios.actions';
import { notificationApiActions } from 'src/app/store/actions/notifications.action';
import { selectIsAuthenticated, selectToken, selectUserBenId } from 'src/app/store/selectors/authentication.selectors';
import { authApiActions } from '../../store/actions/authentication.actions';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { PushService } from 'src/app/core/services/push.service';
import type { MessagePayload } from 'firebase/messaging';

@Injectable()
export class DashboardFacade {
  private store = inject(Store);
  private authenticationService = inject(AuthenticationService);
  private pushService = inject(PushService);

  public foregroundPush$ = this.pushService.foregroundMessages$;

  public get isAuthenticated(): Observable<boolean> {
    return this.store
      .select(selectIsAuthenticated)
      .pipe(first(isAuthenticated => !isAuthenticated));
  }

  public dispatchAuthorizations(id: number) {
    this.store.dispatch(authorizationsApiActions.selectAuthorizationsRequest({ id }));
  }

  public dispatchUnreadCount() {
    this.store.select(selectUserBenId).pipe(first()).subscribe(benId => {
      if (benId) this.store.dispatch(notificationApiActions.unreadCountRequest({ benId }));
    });
  }

  public showPushNotification(payload: MessagePayload) {
    return this.pushService.showNotification(payload);
  }

  public dispatchPushReceived() {
    this.store.dispatch(notificationApiActions.pushReceived());
  }

  public registerPush() {
    this.store.select(selectToken).pipe(first()).subscribe(token => {
      if (token) this.pushService.register(token, false);
    });
  }

  public logOut() {
    this.authenticationService.logout()
  }
}
